module.exports = __webpack_public_path__ + "img/grantType.598a96c3.svg";